import React, { useState, useContext, useEffect, Fragment } from "react";
import Colorer from "color";
import { Link } from "react-router-dom";
import styled, { css, ThemeProvider } from "styled-components";

import { themes } from "../../defaults";
import Bg from "../Bg";

import { OrderLine, Orders, Order, CssCols } from "../account/OrderLine";
import { CartItems } from "../account/CartItems";

import {
  CssImage,
  CssPrice,
  CssPaper,
  Button,
  CssH1,
  CssFormGroup,
  ContentBlock,
  HH,
  CSSpsFormGroup,
  getReasonablePaddings,
  CSSlink,
  HR,
  T,
} from "../uikit-b2c/uikit-b2c";
import {
  methods,
  methodsIcons,
  method_cvs,
  method_visa,
  method_pp,
} from "../uikit-b2c/methods";

import { MethodCard2 } from "./MethodCard2";
import { MethodPP, MethodCVS } from "./MethodPP";
import PSfooter from "./PSfooter";
import { PStotal } from "./PStotal";
import { InputM } from "../uikit-b2c/InputM";
import { PSmethods } from "./PSmethods";
import { TotalPay } from "./TotalPay";
import { PSsection, PSsectionBack } from "./PSsection";
import { PSlogin } from "./PSlogin";
import MethodCard from "./MethodCard";
import { MethodCard1 } from "./MethodCard1";
import { Svg } from "../uikit-b2c/Svg";

// const psThemeAdd = {
//   paddings: 8,
//   fontSize: '14px',
//   fontFamily: ' -apple-system, system-ui, Graphiklcg, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Droid Sans, Helvetica Neue, Arial, sans-serif',
// }

export default function PS0({
  psSections,
  history,
  active = "cart",
  activeMethod = "method_card",
  theme,
  handleTab = () => {
    void 0;
  },
  items = [],
  appearance = "primary",
  extra,
}) {
  const [act, setAct] = useState(active);
  const [saved, setSaved] = useState(false);

  const [method, setMethod] = useState(activeMethod); //method_card//meth_apple//method_cvs

  useEffect(() => {
    if (active !== act) {
      setAct(active);
    }
    // if (activeMethod !== method) {
    //   setMethod(activeMethod)
    // }
  }, [activeMethod, active]);

  return (
    <ThemeProvider theme={theme}>
      <CSSps00>
        <Bg
        // plain={true}
        // style={{opacity: 0.2}}
        />

        {Boolean(psSections) && (
          <CSSps0 theme={theme}>
            {/* <CSSpsBg>
            <Bg
              absolute={true}
              // plain={true}
              // style={{opacity: 0.2}}
            />
          </CSSpsBg> */}

            <CSSpsB>
              <PSsectionBack
                active={false}
                style={{
                  borderRadius: `${theme["borderRadius"]}px`,
                }}
              />

              <PSsection
                order="first"
                active={act === "cart" ? true : false}
                // theme={theme}
                label="Cart"
                section="cart"
                theme={theme}
                handle={() => {
                  history.push(`/ps`);
                  // setAct('cart')
                }}
              >
                {act !== "cart" && (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "2.5fr 1fr",
                      gridColumnGap: 32,
                      alignItems: "center",
                      padding: "16px 0 0 0",
                    }}
                  >
                    <CartItems
                      limit={1}
                      filter={
                        psSections["cart"]["items"]["itemType"]["value"]
                      }
                      collapsed={true}
                    />

                    <PStotal theme={theme} show={["cart"]} />
                  </div>
                )}

                {act === "cart" && (
                  <div>
                    <CartItems
                      limit={1}
                      filter={
                        psSections["cart"]["items"]["itemType"]["value"]
                      }
                      collapsed={false}
                    />

                    <CssFormGroup
                      alignment={"stretch"}
                      style={{
                        paddingTop: 24,
                        marginBottom: 0,
                        marginTop: 16,
                        borderTop: `1px solid ${Colorer(theme["colorText"])
                          .alpha(0.1)
                          .string()}`,
                      }}
                      indentation="lg"
                    >
                      <CSSpsFormFooter active={true}>
                        <div className="">
                          <Button appearance="ghost" size="sm">
                            Apply coupon
                          </Button>
                        </div>
                        <HH paddings={false} tag="h3">
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            Subtotal:&nbsp;&nbsp;<CssPrice>$29.81</CssPrice>
                            {psSections["cart"]["items"]["checkoutStyle"][
                              "value"
                            ] === "button" && (
                              <div style={{ marginLeft: 16 }}>
                                <Button size="sm">
                                  <Link to="/ps/method_card" />
                                  Check out
                                </Button>
                              </div>
                            )}
                          </div>
                        </HH>
                        {/* <Button
                        // appearance="secondary"
                      size="sm">Check out</Button> */}
                      </CSSpsFormFooter>
                    </CssFormGroup>

                    {psSections["cart"]["items"]["checkoutStyle"]["value"] ===
                      "methods" &&
                      act === "cart" && (
                        <CssFormGroup alignment={"space-between"}>
                          <CssFormGroup>
                            <HH tag="h5" paddings={false}>
                              Pay with:
                            </HH>
                          </CssFormGroup>

                          <ContentBlock appearance="flatten" indentation="lg">
                            {/* Cart page */}
                            <PSmethods
                              methods={methods}
                              monochrome={
                                psSections["cart"]["items"]["payment"]["value"]
                              }
                              compact={true}
                              // show = {[]}
                              theme={theme}
                              handle={(m) => {
                                // setAct('methods')
                                setTimeout(() => {
                                  history.push(`/ps/${m}`);
                                  setAct(m);
                                }, 0);
                              }}
                              limit={5}
                            />
                          </ContentBlock>

                          <ContentBlock appearance="flatten">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <CSSlink to="/ps/method_cash">
                                <Button appearance="flatten" size="sm">
                                  Pay with cash
                                </Button>
                              </CSSlink>
                              &nbsp;&nbsp;
                              <CSSlink to="/ps/method_installments">
                                <Button appearance="flatten" size="sm">
                                  Pay in installments
                                </Button>
                              </CSSlink>
                              <div
                                style={{
                                  display: "flex",
                                  flexGrow: 1,
                                  justifyContent: "flex-end",
                                }}
                              >
                                <CSSlink to="/ps/choose">
                                  <Button appearance="flatten" size="sm">
                                    More than 700 payment methods
                                  </Button>
                                </CSSlink>
                              </div>
                            </div>
                          </ContentBlock>
                        </CssFormGroup>
                      )}

                    {psSections["cart"]["items"]["login"]["value"] && (
                      <div>
                        <HR indentation="xs" />
                        <ContentBlock
                          appearance="flatten"
                          indentation={0}
                          paddings={1}
                        >
                          <PSlogin />
                        </ContentBlock>
                      </div>
                    )}
                  </div>
                )}

                {/* )} */}
              </PSsection>

              <PSsection
                order="first"
                active={act === "choose" ? true : false}
                // theme={theme}
                label="Choose payment method"
                section="choose"
                theme={theme}
                handle={() => {
                  history.push(`/ps/`);
                  // setAct('cart')
                }}
              >
                {act === "choose" && (
                  <CssFormGroup alignment={"space-between"}>
                    <ContentBlock appearance="flatten" indentation="lg">
                      {/* Methods page */}
                      <PSmethods
                        search={true}
                        width={120}
                        height={64}
                        // compact={true}
                        methods={methods}
                        monochrome={
                          psSections["cart"]["items"]["payment"]["value"]
                        }
                        // show = {[]}
                        theme={theme}
                        handle={(m) => {
                          // setAct('methods')
                          history.push(`/ps/${m}`);
                          setAct(m);
                        }}
                        limit={16}
                      />
                    </ContentBlock>
                  </CssFormGroup>
                )}

                {/* )} */}
              </PSsection>

              <PSsection
                active={act.includes("method_") ? true : false}
                // active={true}
                theme={theme}
                section="methods"
                handle={() => {
                  history.push(`/ps/${method}`);
                }}
                // label="Pay with credit/debit card"
                label={methods[act] ? methods[act]["pay"] : "Pay with"}
                beforeLabel={
                  <ContentBlock appearance="flatten" indentation={4}>
                    {/* Payment page */}
                    <PSmethods
                      rows={1}
                      width={120}
                      height={64}
                      compact={true}
                      methods={methods}
                      monochrome={
                        psSections["cart"]["items"]["payment"]["value"]
                      }
                      // show = {[]}
                      theme={theme}
                      name={false}
                      tooltip={true}
                      handle={(m) => {
                        // setAct('methods')
                        history.push(`/ps/${m}`);
                        setAct(m);
                      }}
                      limit={3}
                      more="Show more"
                    />
                  </ContentBlock>
                }
              >
                {act.includes("status") && (
                  <Fragment>
                    <ContentBlock appearance="flatten" indentation={4}>
                      {/* <div style={{background:'white',}}> */}
                      {/* <PSmethods
                            methods={methods}
                            // monochrome={psSections["cart"]["items"]["payment"]["value"]}
                            monochrome={true}
                            compact={true}
                            // show = {[]}
                            theme={theme}
                            // handle={(m) => {
                            //   // setAct('methods')
                            //   setTimeout(()=>{
                            //     history.push(`/ps/${m}`);
                            //     setAct(m);
                            //   },0)
                            // }}
                            limit={5}
                          /> */}
                      <div
                        style={{
                          padding: "16px 0",
                        }}
                      >
                        Mastercard **** **** **** 5622
                      </div>
                      {/* </div> */}
                    </ContentBlock>
                  </Fragment>
                )}

                {act.includes("method_") && (
                  <CSSmethCard>
                    <ContentBlock>
                      {act === "method_card" && (
                        <Fragment>
                          {psSections["method_card"]["items"]["cardVisual"][
                            "value"
                          ] === "oldschool" && (
                            <MethodCard1 saved={saved} theme={theme} />
                          )}
                          {psSections["method_card"]["items"]["cardVisual"][
                            "value"
                          ] === "abstract" && (
                            <MethodCard2 saved={saved} theme={theme} />
                          )}
                        </Fragment>
                      )}
                      {act === "method_pp" && <MethodPP theme={theme} />}
                      {act === "method_apple" && <MethodPP theme={theme} />}
                      {act === "method_cvs" && <MethodCVS theme={theme} />}
                      {act === "method_cash" && <MethodPP theme={theme} />}
                      {act === "method_amex" && <MethodCard2 theme={theme} />}

                      <ContentBlock indentation="md">
                        <PSlogin />
                      </ContentBlock>

                      {/* <HR /> */}

                      <ContentBlock appearance="flatten" indentation="md">
                        <T opacity={0.8} xs>
                          By submitting payment information you acknowledge that
                          you have read, understood and agree to be bound by
                          Xsolla’s End-User License Agreement, Privacy Policy,
                          and Refund Policy. Please note that the merchant name
                          on your payment method statement will read as Xsolla
                          (USA), Inc.
                        </T>
                      </ContentBlock>

                      {act === "method_card" && (
                        <ContentBlock indentation={2}>
                          <TotalPay
                            ffr="loyal"
                            handle={(nw) => {
                              history.push(`/ps/${nw}`);
                            }}
                            blocked={true}
                          />
                        </ContentBlock>
                      )}
                    </ContentBlock>

                    {act.includes("method_") && (
                      <PStotal theme={theme} show={["vat", "fee", "grand"]} />
                    )}
                  </CSSmethCard>
                )}
              </PSsection>

              <PSsection
                active={act === "status" ? true : false}
                theme={theme}
                section="status"
                handle={() => {
                  history.push(`/ps/status`);
                }}
                label="Thank you!"
                // order="last"
              >
                {act === "status" && (
                  <div className="">
                    <ContentBlock>
                      Your purchase will be delivered to:{" "}
                    </ContentBlock>
                    <InputM label="Email" value="mikoza@gmail.com" />
                  </div>
                )}
              </PSsection>

              <PSsection
                active={false}
                theme={theme}
                section="footer"
                // handle={setAct}
                // label="Thank you!"
                order="last"
              >
                <PSfooter theme={theme} />
              </PSsection>
            </CSSpsB>
          </CSSps0>
        )}
      </CSSps00>
    </ThemeProvider>
  );
}

const CSSmethCard = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 1fr;
  grid-column-gap: ${({ theme }) =>
    theme &&
    css`
      ${getReasonablePaddings(theme["paddings"]) + 24}px
    `};
`;

const CSSpsCartPic = styled.div`
  width: 64px;
  height: 64px;
  background: ${(props) => props.theme["colorText"]};
  border-radius: ${(props) => `${props.theme["borderRadius"]}px`};
`;

const CSSpsCartLine = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CSSpsFormFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({ active }) =>
    !active &&
    css`
      position: absolute;
      top: 0;
      right: 0;
      min-height: 60px;
    `}
`;

const CSSps00 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  /* background: black; */
  min-height: 100vh;
  padding-top: 15vh;
`;

const CSSpsBg = styled.div`
  opacity: 0.6;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 1;
  overflow: hidden;
  /* background: ${(props) => props.theme["colorBg"]}; */
  /* background: red; */
  /* border-radius: ${(props) => `${props.theme["borderRadius"]}px`}; */
`;

const CSSps0 = styled.div`
  position: relative;
  flex-direction: column;
  max-width: ${({ theme }) => theme["psWidth"]}px;
  padding: 0 24px;
  width: 100%;
  /* box-shadow: 0px 14px 64px rgba(0, 0, 0, 0.04); */
  border-radius: 2px;
  display: flex;
  align-items: space-between;
  justify-content: center;
  /* background: ${(props) => props.theme["colorBg"]}; */
  font-size: ${(props) => props.theme["fontSize"]};
  color: ${(props) => props.theme["colorText"]};
`;

const CSSpsF = styled.div`
  border-radius: 8px;
  width: 100%;
  /* padding: 16px 44px; */
  position: relative;
  border-bottom-right-radius: ${(props) => `${props.theme["borderRadius"]}px`};
  border-bottom-left-radius: ${(props) => `${props.theme["borderRadius"]}px`};
  overflow: hidden;
  &::after {
    opacity: 0.05;
    content: '';
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    /* background: ${(props) => props.theme["colorBg"]}; */
    opacity: 1;
    z-index: 0;
  }
`;

const CSSpsB = styled.div`
  flex-grow: 1;
  /* padding: 0 44px; */
  position: relative;
  z-index: 1;
`;
